<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :starting-stock-balance="form.balance"
    :removal-callback="remove"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in labelsWithoutTextArea"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-lg-12">
          <div class="col-lg-6">
            <fieldset>
              <label>Текстовое описание</label>
              <textarea
                class="form-control"
                :disabled="actionType === 'read'"
                :maxlength="maxLength['text_description']"
                placeholder="Отсутствует"
                v-model.trim="form.text_description"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="control-label">
          Изображение
          <label v-if="actionType !== 'read'" class="field__label_required">
            *
          </label>
        </label>
        <ImageInput
          :preview-image="previewImage"
          :only-preview-image="actionType === 'read'"
          @on-select-file="setImage"
          @on-delete="deleteImage"
        />
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { stockComponentService } from "@/stock/api-services";

import ImageInput from "@/_shared/features/form/ImageInput";
import Form from "@/_shared/widgets/Form";

import { useForm, useNotification, useImageField } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useImageField,
  ],
  components: {
    Form,
    ImageInput,
  },
  data() {
    return {
      fallbackLink: "/promotional_products",
      entityName: {
        readonly: "Рекламная продукция",
        modify: "рекламной продукции",
      },
      form: createFromKeys(formsFields.promotionalProduct.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const addingFields = createCopy(this.form);
    const callback = stockComponentService.get("promotional_products");
    await this.setFormFields(addingFields, callback).then(() => {
      this.checkPreviewImageExistence();
    });
  },
  computed: {
    maxLength() {
      return formsFields.promotionalProduct.maxlength;
    },
    validationSchema() {
      return schemas.promotionalProduct;
    },
    labelsWithoutTextArea() {
      const results = {};
      for (const fieldName in formsFields.promotionalProduct.labels) {
        if (fieldName !== 'text_description') {
          results[fieldName] = formsFields.promotionalProduct.labels[fieldName];
        }
      }
      return results;
    },
  },
  methods: {
    async remove() {
      return await stockComponentService.remove([this.form.id], 'promotionalProduct');
    },
    async submit() {
      const callback = async () => {
        return await this.encodeImage()
          .then(async () => {
            return await stockComponentService[this.actionType](
              this.form, "promotionalProduct", this.image,
            );
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      };
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/PromotionalProductForm.vue